import ExporterParcels from "./ExporterParcels";

export default ExporterParcels;
